import request from '@/utils/request'
import { AxiosPromise } from 'axios'
export function getCategories(data: Record<string, any>): AxiosPromise<any> {
  return request({
    url: '/api/design-engine/template/category',
    method: 'get',
    params: data,
  })
}
export function recommendations(data: Record<string, any>): AxiosPromise<any> {
  return request({
    url: '/api/design-engine/template/recommendations',
    method: 'get',
    params: data,
  })
}







export function getmaterials(data: Record<string, any>): AxiosPromise<any> {
  return request({
    url: '/api/design-engine/template/list',
    method: 'get',
    params: data,
  })
}
export function uploadMaterials(data: Record<string, any>): AxiosPromise<any> {
  return request({
    url: '/api/design-engine/materials/upload',
    method: 'post',
    data: data,
  })
}
export function createDesign(data: Record<string, any>): AxiosPromise<any> {
  return request({
    url: '/api/design/resource',
    method: 'post',
    data: data,
  })
}


export function getCanvasDpi(data: Record<string, any>): AxiosPromise<any> {
  return request({
    url: '/api/design/getCanvasDpi',
    method: 'post',
    data,
  })
}
export function saveCanvasDpi(data: Record<string, any>): AxiosPromise<any> {
  return request({
    url: '/api/design/saveCanvasDpi',
    method: 'post',
    data,
  })
}
export function authUser(data: Record<string, any>): AxiosPromise<any> {
  return request({
    url: '/api/auth/user',
    method: 'post',
    data,
  })
}







export function getVectorCategory(data: Record<string, any>): AxiosPromise<any> {
  return request({
    url: '/api/design-engine/vector/category',
    method: 'get',
    params: data,
  })
}
export function getVectorList(data: Record<string, any>): AxiosPromise<any> {
  return request({
    url: '/api/design-engine/vector/list',
    method: 'get',
    params: data,
  })
}
export function getCollectionPages(data: Record<string, any>): AxiosPromise<any> {
  return request({
    url: '/api/design-engine/collection/category',
    method: 'get',
    params: data,
  })
}

export function getCollectionItems(data: Record<string, any>): AxiosPromise<any> {
  return request({
    url: '/api/design-engine/collection/list',
    method: 'get',
    params: data,
  })
}
export function getMaterialsPages(data: Record<string, any>): AxiosPromise<any> {
  return request({
    url: '/api/design-engine/materials/category',
    method: 'get',
    params: data,
  })
}

export function getMaterialsItems(data: Record<string, any>): AxiosPromise<any> {
  return request({
    url: '/api/design-engine/materials/list',
    method: 'get',
    params: data,
  })
}
export function getMaterialsRecommendations(data: Record<string, any>): AxiosPromise<any> {
  return request({
    url: '/api/design-engine/materials/recommendations',
    method: 'get',
    params: data,
  })
}



// 创建文件夹
export function createFolder(data: Record<string, any>): AxiosPromise<any> {
  return request({
    url: '/api/design/resource/folder',
    method: 'post',
    data: data,
  })
}
//获取文件夹列表
export function getFolderList(data: Record<string, any>): AxiosPromise<any> {
  return request({
    url: '/api/design/resource/folder',
    method: 'get',
    params: data,
  })
}

export function getResourceList(data: Record<string, any>): AxiosPromise<any> {
  return request({
    url: '/api/design/resource/pages',
    method: 'get',
    params: data,
  })
}
export const getResourceCapacity = (params: any) => {
  return request({
    url: '/api/design/resource/capacity',
    method: 'get',
    params
  })
}
export const designDownloadFile = (params: any) => {
  return request({
    url: '/api/design/download/file',
    method: 'post',
    data: params,
  })
}
//获取素材源列表
export const getMaterialSources = (params: any) => {
  return request({
    url: '/api/design-engine/materialSources/list',
    method: 'get',
    params
  })
}
// 搜索素材源
export const searchMaterialSources = (params: any) => {
  return request({
    url: '/api/design-engine/materialSources/search',
    method: 'post',
    data: params
  })
}
// 获取素材源详情
export const getMaterialSourceDetails = (params: any) => {
  return request({
    url: '/api/design-engine/materialSources/get-details',
    method: 'get',
    params
  })
}
export const getFolderTree = (params: any) => {
  return request({
    url: '/api/design/resource/getFolderTree',
    method: 'get',
    params
  })
}
export const appendFileToFolder = (params: any) => {
  return request({
    url: '/api/design/resource/appendFileToFolder',
    method: 'post',
    data: params
  })
}
export const designTeam = (params: any) => {
  return request({
    url: 'api/design/team',
    method: 'post',
    data: params
  })
}
export const getSystemConfig = (params: any) => {
  return request({
    url: 'api/design/common/getSystemConfig',
    method: 'get',
    params
  })
}
export const segmentationCreate = (params: any) => {
  return request({
    url: '/api/design/segmentationCreate',
    method: 'post',
    data: { ...params, ...{ id: 1, sync: 1 } }
  })
}
